import React from 'react'
import { Alert, Checkbox, Form, Input, Select, Spin } from 'antd'
import { REGION_TYPES } from '../CoverageCommon'
import container from './container'

const RegionEditor = props => {
    const { lst, syncing, supplierCode, $form, $props, $loading, $fieldProps } = props

    const hint = field => (lst && lst[field] ? `lst_region: ${lst[field]}` : undefined)

    return (
        <Spin spinning={$loading}>
            <Form {...$props} colon={false} layout={'vertical'} wrapperCol={{ flex: 1 }}>
                {$form.Item({ name: 'region_id' })}
                {$form.Item({ name: 'supplier_code' })}
                <Alert
                    type="info"
                    showIcon
                    message={
                        supplierCode
                            ? `Rewrites the metadata on the ${supplierCode} rows of this region only.`
                            : 'Rewrites the metadata on every hotel_mapping_v2 row of this region.'
                    }
                />
                <br />
                <Form.Item name={'sync_from_lst_region'} {...$fieldProps.sync_from_lst_region}>
                    <Checkbox disabled={!lst}>
                        {lst ? 'Sync from lst_region' : 'Sync from lst_region (region not in lst_region)'}
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name={'region_name'}
                    label={'Region name'}
                    extra={hint('region_name')}
                    {...$fieldProps.region_name}>
                    <Input disabled={syncing} />
                </Form.Item>
                <Form.Item name={'region_name_full'} label={'Full name'} extra={hint('region_name_full')}>
                    <Input disabled={syncing} />
                </Form.Item>
                <Form.Item
                    name={'region_type'}
                    label={'Region type'}
                    extra={hint('region_type')}
                    {...$fieldProps.region_type}>
                    <Select disabled={syncing} placeholder={'Select a region type'}>
                        {REGION_TYPES.map(type => (
                            <Select.Option value={type} key={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={'country_code'}
                    label={'Country'}
                    extra={hint('country_code')}
                    {...$fieldProps.country_code}>
                    <Input disabled={syncing} maxLength={2} />
                </Form.Item>
            </Form>
        </Spin>
    )
}

export default container(RegionEditor)
